module.exports = __webpack_public_path__ + "img/p-xinwang.e1a16fe6.png";